import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=33cf4a00&scoped=true&lang=pug"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"
import style0 from "./Cell.vue?vue&type=style&index=0&id=33cf4a00&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cf4a00",
  null
  
)

export default component.exports